import { NgModule } from "@angular/core";
import { OutlookCalendarConnectionComponent } from "./outlook-calendar-connection/outlook-calendar-connection.component";
import { GoogleCalendarConnectionComponent } from "./google-calendar-connection/google-calendar-connection.component";
import { GmailConnectionComponent } from "./gmail-connection/gmail-connection.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { StripeConnectionComponent } from "./stripe-connection/stripe-connection.component";
import { EnologiaConnectionComponent } from "./enologia-connection/enologia-connection.component";
import { ManavaConnectionComponent } from "./manava-connection/manava-connection.component";
import { DivineaConnectionComponent } from "./divinea-connection/divinea-connection.component";
import { DwspayConnectionComponent } from "./dwspay-connection/dwspay-connection.component";


@NgModule({
  declarations: [
    OutlookCalendarConnectionComponent,
    GoogleCalendarConnectionComponent,
    GmailConnectionComponent,
    StripeConnectionComponent,
    EnologiaConnectionComponent,
    ManavaConnectionComponent,
    DivineaConnectionComponent,
    DwspayConnectionComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
  ],
  exports: [
    OutlookCalendarConnectionComponent,
    GoogleCalendarConnectionComponent,
    GmailConnectionComponent,
    StripeConnectionComponent,
    EnologiaConnectionComponent,
    ManavaConnectionComponent,
    DivineaConnectionComponent,
    DwspayConnectionComponent,
  ],
})
export class FragmentsModule {}